var _rect, _g, _rect2, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThemeLight = function SvgThemeLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 4,
    y: 4,
    fill: "#F2F2F7",
    rx: 9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#themeLight_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 20,
    x: 9,
    y: 34,
    fill: "#fff",
    rx: 3
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10,
    x: 12,
    y: 39,
    fill: "#000",
    fillOpacity: 0.04,
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 4,
    x: 29,
    y: 39,
    fill: "#000",
    fillOpacity: 0.04,
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 4,
    x: 29,
    y: 45,
    fill: "#000",
    fillOpacity: 0.04,
    rx: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "themeLight_svg__a",
    width: 80.8,
    height: 30.8,
    x: 3.6,
    y: 30,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.45
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.675
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_861"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_17_861",
    result: "effect2_dropShadow_17_861"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_17_861",
    result: "shape"
  })))));
};
export default SvgThemeLight;